import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@components/shadcn-ui/dialog";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@components/shadcn-ui/select";
import { toTitleCase } from "../utils";

export type FileCategory =
    | "APPLICATION"
    | "PAN"
    | "AADHAR"
    | "BANK"
    | "PROJECT"
    | "INVOICE"
    | "RESIDENCE_VERIFICATION_REPORT"
    | "SANCTION_LETTER"
    | "OTHERS"
    | "TASK_ATTACHMENTS"
    | "RESIDENCE_VERIFICATION_FORM";

export const DOCUMENT_CATEGORIES: FileCategory[] = [
    "APPLICATION",
    "PAN",
    "AADHAR",
    "BANK",
    "PROJECT",
    "INVOICE",
    "OTHERS",
    "SANCTION_LETTER",
    "RESIDENCE_VERIFICATION_REPORT",
];

export const TASK_PAGE_DOCUMENT_CATEGORIES: FileCategory[] = [
    "TASK_ATTACHMENTS"
];

interface FileCategoryModalProps {
    showModal: boolean;
    setShowModal: (show: boolean) => void;
    handleCategorySelect: (category: FileCategory) => void;
    documentCategories: FileCategory[];
}

export const FileCategoryModal = ({
                                      showModal,
                                      setShowModal,
                                      handleCategorySelect,
                                      documentCategories,
                                  }: FileCategoryModalProps) => {
    return (
        <Dialog open={showModal} onOpenChange={setShowModal}>
            <DialogContent className="sm:max-w-[425px] w-[95%] mx-auto rounded-lg">
                <DialogHeader className="pt-6 pb-4">
                    <DialogTitle className="text-center text-xl">
                        Select File Type
                    </DialogTitle>
                </DialogHeader>
                <div className="px-6 pb-6">
                    <Select onValueChange={(value) => handleCategorySelect(value as FileCategory)}>
                        <SelectTrigger className="w-full">
                            <SelectValue placeholder="Select a file type" />
                        </SelectTrigger>
                        <SelectContent className="max-h-[300px]">
                            {documentCategories.map((category) => (
                                <SelectItem
                                    key={category}
                                    value={category}
                                    className="cursor-pointer"
                                >
                                    {category === "RESIDENCE_VERIFICATION_REPORT"
                                        ? "RV Report"
                                        : toTitleCase(category)}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            </DialogContent>
        </Dialog>
    );
};
